<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Waves Effect</h1>
					<p waBody="m" waText>Material-design inspired click/tap ripple effect using Waves.js &mdash; adds beautiful ripple animations to buttons and interactive elements with multiple style variants &#40;Light, Circle, Button, Float, Block&#41;.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Waves 0.7.6</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:waveseffect</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.waveseffect</p>
					<p waBody="s" waText>Built on: Waves.js 0.7.6</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_673" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_674" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_675" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;5&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WavesEffectPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Page configurator that auto-registers node-waves JS and SCSS stylesheet for material ripple click effects. Implements IPageConfigurator.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/waves/waves-effect-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WavesEffects</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 6 CSS class variants for wave ripple styling. Values render as lowercase dash-separated CSS classes &#40;e.g. Waves&#95;Light becomes waves-light&#41;.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">6 props</wa-tag>
									<wa-tag pill variant="neutral">1 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/waves/waves-effects']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WavesAttachFeature</h4>
								<p waBody="s" waColorText="quiet" waText>Feature that calls Waves.init&#40;&#41; to initialize the ripple click effect on the attached component. Extends Feature.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">1 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/waves/waves-attach-feature']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WavesApplyToSelectorFeature</h4>
								<p waBody="s" waColorText="quiet" waText>Feature that applies Waves.attach&#40;selector, classes&#41; to target elements by CSS selector with specified effect variants. Extends Feature.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
									<wa-tag pill variant="neutral">5 methods</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/waves/waves-apply-to-selector-feature']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WavesEffectsInclusionModule</h4>
								<p waBody="s" waColorText="quiet" waText>Guice module scan inclusion &mdash; ensures the Waves Effect plugin module is included in classpath scanning. Implements IGuiceScanModuleInclusions.</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/waves/waves-effects-inclusion-module']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (7)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Material ripple effect &mdash; Google Material Design inspired click/tap animations</p>
						<p waBody="s" waColorText="quiet" waText>Multiple effect styles &mdash; Light, Circle, Button, Float, Block variants</p>
						<p waBody="s" waColorText="quiet" waText>CSS selector targeting &mdash; apply waves to any DOM elements via selector</p>
						<p waBody="s" waColorText="quiet" waText>Auto-initialization &mdash; Waves.init&#40;&#41; called automatically via feature</p>
						<p waBody="s" waColorText="quiet" waText>SCSS styles included &mdash; full Waves stylesheet auto-registered</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe enum &mdash; WavesEffects enum for all effect variants</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (3)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Initialize Waves on a component</h4>
							<p waBody="s" waColorText="quiet" waText>Attach ripple effect to a button.</p>
							<markdown [data]="mdContent_676" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Apply to CSS selector</h4>
							<p waBody="s" waColorText="quiet" waText>Apply light wave effect to all elements matching a selector.</p>
							<markdown [data]="mdContent_677" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Module requirement</h4>
							<p waBody="s" waColorText="quiet" waText>Add to your module-info.java.</p>
							<markdown [data]="mdContent_678" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_679" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (2)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>WavesEffectPageConfigurator auto-registers node-waves JS and SCSS files</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceScanModuleInclusions</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>WavesEffectsInclusionModule ensures the Waves module is included in Guice classpath scanning</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://github.com/fians/Waves</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fians.github.io/Waves/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>